<template>
  <div>
    <v-content>
      <v-card>
        <v-container fluid grid-list-xl>
          <v-layout row wrap>
            <v-flex             
              v-for="element in last_directories"
              v-bind="{ [`md${3}`]: true, [`sm${3}`]: true }"
              :key="element.uuid"
            >
              <v-card dark class="module_card">
                 <!-- ANCIENEMENT CARD-DIRECTORY -->
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="edit(element)">
                    <v-icon>create</v-icon>
                  </v-btn>
                  <v-btn icon @click="enterTo(element)">
                    <v-icon>open_in_browser</v-icon>
                  </v-btn>
                  <v-btn icon @click="deleteEle(element)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-content>
  </div>
</template>

<script>

export default {
  name: "latestProjects",
  props: {
    source: String
  },
  mounted: async function() {
    await this.swithDispatch("/projects");
    await this.getMethodAsync("/projects");
    await this.getLastProjects();
  },
  data() {
    return {
      elements: [],
      route_current: this.$route.path,
      last_directories: null
    };
  },
  computed: {
    getLastProjects() {
      return this.$store.getters["project/getProjectsAnyParent"];
    }
  },
  methods: {
    async getLastProjects() {
      this.last_directories = await this.$store.getters[
        "project/getProjectsSansParent"
      ];
    },
    async getMethodAsync(route) {
      this.elements = await this.getterElements(route);
    },
    edit(element) {
      let uuid = element.uuid;
      this.$router.push({
        path: "/projects/edit/" + uuid
      });
    },
    enterTo(element) {
      let uuid = element.uuid;
      this.$router.push({
        path: "/projects/" + uuid
      });
    },
    deleteEle(element) {
      
      if (element == null || element == undefined) {
        alert("deleteEle error");
      }
      switch (this.route_current) {
        case "/medias":
          this.$store.dispatch("image/deleteMedia", element.uuid);
          break;
        case "/projects":
          this.$store.dispatch("project/delProject", element.uuid);
          break;
        case "/reports":
          this.$store.dispatch("report/deleteReport", element.uuid);
          break;
        default:
          break;
      }
    },
    rainbow() {
      // let gradient = 'background: linear-gradient(217deg, rgb(15, 84, 195), rgb(43, 202, 172), linear-gradient(127deg, rgb(15, 84, 195), rgb(43, 202, 172)) ';
      let gradient =
        "background: linear-gradient(217deg, rgba(15,84,195,0), rgba(43,202,172,.3) 70.71%), linear-gradient(127deg, rgba(153,153,153,.8), rgba(255,255,255,0) 70.71%), linear-gradient(336deg, rgba(15,84,195,.8), rgba(15,84,255,0) 70.71%)";
      return gradient;
    },
    async swithDispatch(method) {
      switch (method) {
        case "/medias":
          await this.$store.dispatch("image/getImages");
          break;
        case "/projects":
          await this.$store.dispatch("project/getProjects");
          break;
        case "/reports":
          await this.$store.dispatch("report/getReports");
          break;
        default:
          break;
      }
    },
    async getterElements(name_method) {
      let app = this;
      let elements = null;
      switch (name_method) {
        case "/medias":
          elements = await app.$store.getters["image/getImages"];
          break;
        case "/projects":
          elements = await app.$store.getters["project/getProjectsAnyParent"];
          break;
        case "/reports":
          elements = await app.$store.getters["report/getReports"];
          break;
        default:
          break;
      }
      return elements;
    }
  },
  watch: {
    async $route(to, from) {
      await this.swithDispatch("/projects");
      await this.getMethodAsync("/projects");
      this.route_current = to.path;
    }
  }
};
</script>
